<template>
  <a-modal
    :title="title"
    :width="800"
    :visible="visible"
    @ok="handleOk"
    @cancel="handleCancel"
    :bodyStyle="{ overflow: 'unset' }"
  >
    <a-spin :spinning="loading">
      <a-form :form="form" @keyup.enter.native="handleOk">
        <a-form-item :label="$t('disp.postCode')" :labelCol="{ span: 5 }" :wrapperCol="{ span: 16 }">
          <a-input
            :placeholder="$t('disp.ph.input', [$t('disp.postCode')])"
            v-decorator="['code', validatorRules.code]"
            :disabled="!!model.id"
            :maxLength="100"
          />
        </a-form-item>
        <a-form-item :label="$t('disp.postName')" :labelCol="{ span: 5 }" :wrapperCol="{ span: 16 }">
          <a-input
            :placeholder="$t('disp.ph.input', [$t('disp.postName')])"
            v-decorator="['name', validatorRules.name]"
            :maxLength="100"
          />
        </a-form-item>
        <a-form-item :label="$t('disp.postRank')" :labelCol="{ span: 5 }" :wrapperCol="{ span: 16 }">
          <a-slider v-model="postRank" :marks="marks" :min="0" :max="100" />
        </a-form-item>
      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>
import pick from 'lodash/pick'
import { httpAction, getAction } from '@/api/manage'
import { duplicateCheck } from '@/api/api'
import JDictSelectTag from '@/components/dict/JDictSelectTag'

let validatorCodeTimer = null

export default {
  name: 'PositionModal',
  components: { JDictSelectTag },
  data() {
    return {
      title: '操作',
      postRank: 0,
      visible: false,
      model: {},
      loading: false,
      form: this.$form.createForm(this),
      marks: {},
      validatorRules: {
        code: {
          rules: [{ required: true, message: this.$t('disp.rules.require') }, { validator: this.validatePostCode }],
        },
        name: {
          rules: [{ required: true, message: this.$t('disp.rules.require') }, { validator: this.validatePostName }],
        },
      },
      url: {
        add: '/blaze-sys/k00/k0009/PositionManage/add',
        edit: '/blaze-sys/k00/k0009/PositionManage/edit',
        maxRank: '/blaze-sys/k00/k0009/PositionManage/maxRank',
        getMarks: '/blaze-sys/k00/k0009/PositionManage/getMarks',
      },
    }
  },
  created() {},
  methods: {
    getMarks() {
      getAction(this.url.getMarks, {}).then((res) => {
        if (res.success) {
          this.marks = res.result
          for (var key in this.marks) {
            var source = this.marks[key]
            this.marks[key] = {
              label: source.split('/').map((r) => {
                return (
                  <span>
                    <j-empty></j-empty>
                    <li>{r}</li>
                  </span>
                )
              }),
            }
          }
        }
      })
    },
    add() {
      this.edit({})
    },
    edit(record) {
      this.getMarks()
      this.form.resetFields()
      this.model = Object.assign({}, record)
      this.postRank = record.postRank ? Number(record.postRank) : 0
      this.visible = true
      this.$nextTick(() => {
        this.form.setFieldsValue(pick(this.model, 'code', 'name'))
      })
    },
    close() {
      this.$emit('close')
      this.visible = false
    },
    handleOk() {
      if (this.loading) {
        return
      } else {
        this.loading = true
      }

      const that = this
      // フォーム検証をトリガー
      this.form.validateFieldsAndScroll((err, values) => {
        if (!err) {
          let httpUrl = ''
          let method = ''
          if (!this.model.id) {
            httpUrl += this.url.add
            method = 'post'
          } else {
            httpUrl += this.url.edit
            method = 'put'
          }

          let formData = Object.assign(this.model, values)
          formData.postRank = that.postRank
          httpAction(httpUrl, formData, method)
            .then((res) => {
              if (res.success) {
                that.$message.success(this.$t(res.message))
                that.$emit('ok')
              }
            })
            .finally(() => {
              that.loading = false
              that.close()
            })
        } else {
          that.loading = false
        }
      })
    },
    handleCancel() {
      this.close()
    },
    validatePostCode(rule, value, callback) {
      if (/[^\a-\z\A-\Z0-9]/g.test(value)) {
        callback(this.$t('disp.rules.halfCharNum'))
      } else {
        var params = {
          tableName: 'sys_position',
          fieldName: 'code',
          fieldVal: value,
          dataId: this.model.id,
        }
        duplicateCheck(params).then((res) => {
          if (res.success) {
            callback()
          } else {
            callback(this.$t('disp.rules.duplicate', [this.$t('disp.postCode')]))
          }
        })
      }
    },
    validatePostName(rule, value, callback) {
      var params = {
        tableName: 'sys_position',
        fieldName: 'name',
        fieldVal: value,
        dataId: this.model.id,
      }
      duplicateCheck(params).then((res) => {
        if (res.success) {
          callback()
        } else {
          callback(this.$t('disp.rules.duplicate', [this.$t('disp.postName')]))
        }
      })
    },
  },
}
</script>

<style lang="less" scoped>
/deep/ .ant-slider-handle {
  z-index: 999;
}

/deep/ .ant-slider-mark-text {
  width: 28px;
  letter-spacing: 0px;
  line-height: 16px;
  margin-top: 10px;
  background: whitesmoke;
  padding: 5px 10px 6px 8px;
  box-shadow: 1px 2px 4px rgba(0, 0, 0, 20%);
  color: var(--color-font);
  font-size: 13px;
  transition: all 0.3s;
  /* border-bottom-right-radius: 4px; */
  /* border-bottom-left-radius: 4px; */
  /* border-bottom: 2px solid; */
  border-color: #989898;
  color: rgba(0, 0, 0, 0.35);
  padding-top: 20px;
  word-break: break-word;
  border-radius: 2px;
  /* border-right: 2px solid; */
  border-top: 0px solid;

  & > span:first-child {
    .j-empty {
      display: none;
    }
  }

  &::before {
    content: ' ';
    position: absolute;
    background: #e8e8e8;
    width: 2px;
    height: 21px;
    margin-top: -36px;
    z-index: -1;
    transition: all 0.3s;
    left: 13px;
  }

  &::after {
    content: ' ';
    width: 10px;
    height: 10px;
    background: #e8e8e8;
    position: absolute;
    border-radius: 50%;
    top: 5px;
    left: 9px;
    z-index: -2;
    box-shadow: 2px 2px 2px rgba(0, 0, 0, 30%);
    //visibility: hidden;
  }
}

/deep/ .ant-slider-mark-text-active {
  background: linear-gradient(180deg, var(--color-primary-7), var(--color-primary-5));
  border-color: var(--color-primary-3);
  color: white;
  animation: roll-roll 0.4s both ease-out;

  .j-empty,
  &::after,
  &::before {
    // background: #91d5ff;
    background: var(--color-primary-3);
  }
}

.ant-slider-with-marks {
  margin-bottom: 0px;
}

.j-empty {
  left: 2px;
  width: 7px;
  top: 2px;
  background: #e5e5e5;
  height: 7px;
  border-radius: 50%;
  margin: 5px 0;
  box-shadow: 1px 1px 2px rgba(0, 0, 0, 50%);
}
</style>
